<template>
  <div class="row">
    <input :ref="`file-${surveillance.id}`"
           accept="application/pdf"
           v-show="false"
           type="file"
           @change="uploadFile($event)"
           single>
    <div class="col-xs-12">
      <alert :type="alert.type">
        <div class="text-justify" v-html="alert.body">
        </div>
        <p v-if="error !== ''">
          <alert type="danger" class="text-justify">
            {{ error }}
          </alert>
        </p>
        <p v-else-if="alert.roles">
          <btn type="default" @click="showConventionModal()"
               size="lg" block>
            <span v-if="surveillance.cvt.main === 0">Désigner</span>
            <span v-else-if="surveillance.cvt.stat === 2">Voir</span>
            <span v-else>Modifier</span> les signataires
          </btn>
        </p>
        <p v-if="alert.confirm">
          <btn type="primary" @click="confirm" size="lg" block>
            Reconduire la charte existante
          </btn>
        </p>
        <p v-if="alert.generate">
          <btn type="info" @click="generateConvention" size="lg" block>
            Télécharger le document à signer
          </btn>
        </p>
        <p v-if="alert.send">
          <btn :type="surveillance.cvt.stat === 3 ? 'default' : 'warning'"
               block size="lg"
               @click="prepareUpload(null)">
            <span v-if="surveillance.cvt.stat === 3">Renvoyer</span>
            <span v-else>Envoyer</span> le document signé
          </btn>
        </p>
        <div v-if="alert.reg">
          <hr />
          <h4>Changement de Responsable</h4>
          <alert type="info" v-if="alert.reg === 2" class="alert-small">
            <span class="glyphicon glyphicon-time" aria-hidden="true"
                  style="margin-right: 0.7rem;">
            </span>
            <small>
              <strong>
                Avenant bien reçu.
              </strong>
            </small>
          </alert>
          <p>
            <btn type="info" @click="generateAmendment('reg')" size="lg" block>
              Télécharger l'avenant à signer
            </btn>
          </p>
          <p>
            <btn :type="surveillance.cvt.stat === 3 ? 'default' : 'warning'"
               block size="lg"
               @click="prepareUpload(3)">
            Envoyer l'avenant signé
          </btn>
          </p>
        </div>
        <div v-if="alert.dir">
          <hr />
          <h4>
            Changement de Directeur <br /><small>(ou son représentant)</small>
          </h4>
          <alert type="info" v-if="alert.dir === 2" class="alert-small">
            <span class="glyphicon glyphicon-time" aria-hidden="true"
                  style="margin-right: 0.7rem;">
            </span>
            <small>
              <strong>
                Avenant bien reçu.
              </strong>
            </small>
          </alert>
          <p>
            <btn type="info" @click="generateAmendment('dir')" size="lg" block>
              Télécharger l'avenant à signer
            </btn>
          </p>
          <p>
            <btn :type="surveillance.cvt.stat === 3 ? 'default' : 'warning'"
               block size="lg"
               @click="prepareUpload(2)">
              Envoyer l'avenant signé
            </btn>
          </p>
        </div>
        <div v-if="alert.bio">
          <hr />
          <h4>Changement de Biologiste</h4>
          <alert type="info" v-if="alert.bio === 2" class="alert-small">
            <span class="glyphicon glyphicon-time" aria-hidden="true"
                  style="margin-right: 0.7rem;">
            </span>
            <small>
              <strong>
                Avenant bien reçu.
              </strong>
            </small>
          </alert>
          <p>
            <btn type="info" @click="generateAmendment('bio')" size="lg" block>
              Télécharger l'avenant à signer
            </btn>
          </p>
          <p>
            <btn :type="surveillance.cvt.stat === 3 ? 'default' : 'warning'"
               block size="lg"
               @click="prepareUpload(1)">
              Envoyer l'avenant signé
            </btn>
          </p>
        </div>
      </alert>
    </div>

    <convention-modal :surveillance="surveillance"
                      :complete="convention.complete"
                      v-model="convention.modal">
    </convention-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import conventionModal from '@/sui/components/establishment/conventionmodal'
import finess from '@/sui/api/finess'
import impl from '@/sui/data/convention'
import { confirm } from '@/sui/tools/modal'

export default {
  name: 'surveillance-convention',

  props: {
    surveillance: Object
  },

  data () {
    return {
      idle: true,
      error: '',
      uploadPercentage: 0,
      currentStatus: this.surveillance.cvt.stat,
      convention: {
        modal: false,
        edit: true
      },
      targetRole: null
    }
  },

  watch: {
    surveillance: {
      handler () {
        if (this.currentStatus !== this.surveillance.cvt.stat) {
          this.currentStatus = this.surveillance.cvt.stat
          this.idle = true
        }
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      userId: 'user/id',
      userName: 'user/completeName',
      userEmail: 'user/email'
    }),

    isRegistrator: function () {
      return this.surveillance.isRegistrator(this.userId)
    },

    conventionError: function () {
      const { cvt } = this.surveillance
      const e = cvt.error
      if (e === '[UpdatedRegistrator]') {
        if (cvt.main !== 3) {
          return `Le responsable du programme a changé, merci de nous faire
parvenir une nouvelle charte signée.`
        }

        return `Le responsable du programme a changé, merci de nous faire
parvenir l'avenant correspondant signé.`
      }

      return e
    },

    alert: function () {
      const { cvt } = this.surveillance
      if (this.isRegistrator) {
        const user = {
          name: this.userName,
          email: this.userEmail
        }
        return impl.getRegistratorAlert(user, cvt, this.conventionError)
      }

      return impl.getMemberAlert(cvt)
    }
  },

  methods: {
    showConventionModal: function () {
      this.convention.complete = this.surveillance.cvt.stat === 2
      this.convention.modal = true
    },

    prepareUpload: function (role) {
      const id = this.surveillance.id
      this.targetRole = role
      this.$refs[`file-${id}`].click()
    },

    generateAmendment: function (r) {
      const f = this.surveillance.establishment.finess
      const cvt = this.surveillance.cvt
      finess.info(f).then(
        l => {
          const { data } = l
          if (data.err == null) {
            const result = {
              year: this.surveillance.year,
              complete: false,

              establishment: {
                finess: f,
                name: data.n,
                address: data.a
              }
            }
            result[r] = {
              name: cvt[r].name,
              firstName: cvt[r].fn,
              email: cvt[r].eml
            }
            finess.info(f).then(
              r => {
                const { data } = r
                if (data.err == null) {
                  impl.exportPDF(result)
                }
              }
            )
          }
        }
      )
    },

    generateConvention: function () {
      const f = this.surveillance.establishment.finess
      const cvt = this.surveillance.cvt
      finess.info(f).then(
        r => {
          const { data } = r
          if (data.err == null) {
            impl.exportPDF(
              {
                complete: true,
                year: this.surveillance.year,

                establishment: {
                  finess: f,
                  name: data.n,
                  address: data.a
                },

                reg: {
                  name: cvt.reg.name,
                  firstName: cvt.reg.fn,
                  email: cvt.reg.eml
                },

                dir: {
                  name: cvt.dir.name,
                  firstName: cvt.dir.fn,
                  email: cvt.dir.eml
                },

                bio: {
                  name: cvt.bio.name,
                  firstName: cvt.bio.fn,
                  email: cvt.bio.eml
                }
              }
            )
          }
        }
      )
    },

    uploadFile (event) {
      const role = this.targetRole
      const file = event.target.files[0]
      event.target.value = ''

      if (!file) {
        this.error = 'Aucun fichier choisi.'
        event.preventDefault()
        return
      }

      const max = 2
      const limit = max << 20
      if (file.size > limit) {
        this.error = `Le fichier dépasse la taille autorisée (${max}Mo).`
        event.preventDefault()
        return
      }

      const formData = new FormData()
      formData.append('id', this.surveillance.establishment.id)
      formData.append('file', file)
      if (role != null) {
        formData.append('role', role)
      }

      const instance = this
      this.idle = false
      this.error = ''
      this.uploadPercentage = 0

      const request = {
        data: formData,
        year: this.surveillance.year,
        progress: function (progressEvent) {
          instance.uploadPercentage = parseInt(
            Math.round(progressEvent.loaded * 100 / progressEvent.total)
          )
        }
      }

      this.$store.dispatch('surveillances/uploadConvention', request).then(
        function ({ data }) {
          if (data.err != null) {
            instance.idle = true
            instance.error = `Impossible d'envoyer la charte, veuillez vérifier votre
connexion internet avant de réessayer.`
          }
        }
      ).catch(
        function () {
          instance.idle = true
          instance.error = `Impossible d'envoyer la charte, veuillez vérifier votre
connexion internet avant de réessayer.`
        }
      )
    },

    confirm: function () {
      const vm = this
      const cvt = this.surveillance.cvt
      const request = {
        id: this.surveillance.id
      }
      this.idle = false
      this.error = ''
      const error = () => {
        vm.idle = true
        vm.error = `Impossible de reconduire la charte existante,
veuillez vérifier votre connexion internet avant de réessayer.`
      }
      confirm(
        this,
        `<h3>Reconduction de la charte d'engagement</h3>
<p>
  La charte existante a été envoyée avec les signataires suivants :
</p>
<ul>
  <li>
    <strong>Responsable</strong><br />
    ${cvt.reg.fn} ${cvt.reg.name} (${cvt.reg.eml})
  </li>
  <li>
    <strong>Directeur <small>(ou son représentant)</small></strong><br />
    ${cvt.dir.fn} ${cvt.dir.name} (${cvt.dir.eml})
  </li>
  <li>
    <strong>Biologiste</strong><br />
    ${cvt.bio.fn} ${cvt.bio.name} (${cvt.bio.eml})
  </li>
</ul>
<p class="text-justify">
  <strong>
    Une fois reconduite, la charte sera de nouveau soumise à notre équipe afin
    d'être validée.
  </strong>
</p>
<p>
  <strong>
    Êtes vous sûr.e de vouloir reconduire cette charte pour
    l'établissement «${this.surveillance.establishment.name}» ?
  </strong>
</p>
`
      ).then(() => {
        vm.idle = false
        vm.$store.dispatch('surveillances/confirmConvention', request).then(
          (r) => {
            if (r.data.err != null) { error() }
          }
        ).catch(() => { error() })
      }).catch(() => {})
    }
  },

  components: {
    'convention-modal': conventionModal
  }
}
</script>
<style scoped>
.alert:last-child {
    margin-bottom: 0rem;
}

.alert-small {
  padding: 0.5rem 0.9rem;
  margin-bottom: 0.8rem;
}

ul {
  list-style-type: none;
}
</style>
